import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BLACK, WHITE } from '../../../styles/variables.style';

export const ButtonContainer = styled.div``;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto 100px;

  .button {
    width: 220px;
    align-items: center;
    background-color: ${BLACK};
    color: ${WHITE};
    cursor: pointer;
    display: flex;
    height: 64px;
    justify-content: center;
    margin-right: 10px;
    margin-left: 10px;
    ${media.tabletL`
      width: 320px;
    `};
  }

  // ${media.tabletL`
  //   margin-top: 80px;
  // `};
`;



// WEBPACK FOOTER //
// ./src/pages/RangePage/SalonListCTA/SalonListCTA.style.js